import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IContactFlagsView } from 'clickNgo/models/crud/views'
import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapContactFlagFromContactsFlagsView } from './mapping/mapContactFlagFromContactsFlagsView'

interface IFetchContactFlagsParams {
  contactId?: string
  partnerId?: string
  topPartnerId?: string
  type?: ProfilingCodeType
  options?: ICrudFetchOptions
}

export const fetchRawContactFlags = ({
  contactId,
  partnerId,
  topPartnerId,
  type,
  options,
}: IFetchContactFlagsParams): Promise<IContactFlagsView[]> => {
  const source = CrudStore.get<IContactFlagsView, unknown>(
    CrudStoreItem.ContactFlags,
    options?.cacheKey
  )

  const isToolsType = type === ProfilingCodeType.Tools

  const filterByType: IFilter = {
    field: 'Type',
    operator: Operator.EQUAL,
    value: type ?? '',
  }

  const filterByContactId: IFilter = {
    field: 'ContactId',
    operator: Operator.EQUAL,
    value: contactId ?? '',
  }

  const filterByPartnerId: IFilter = {
    field: isToolsType ? 'TopPartnerId' : 'PartnerId',
    operator: Operator.EQUAL,
    value: partnerId ?? '',
  }

  const filterByTopPartnerId: IFilter = {
    field: 'TopPartnerId',
    operator: Operator.EQUAL,
    value: topPartnerId ?? '',
  }

  const filters: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [filterByContactId, filterByPartnerId, filterByTopPartnerId, filterByType].filter(
      ({ value }) => value
    ),
  }

  source.setDefaultFilter(filters)

  if (options?.paging) {
    source.setPaging(options.paging)
  }

  return source
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result) => {
      if (result && result.items) {
        return result.items
      }
      return []
    })
    .catch((error) => {
      Logger.error(error)
      return []
    })
}

export const fetchContactFlags = (props: IFetchContactFlagsParams) =>
  fetchRawContactFlags(props).then((result) => result.map(mapContactFlagFromContactsFlagsView))
